import { p as proxyCustomElement, H, h, a as Host } from './index.js';

const tagListCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-content:flex-start;background:#0000;box-sizing:border-box;display:flex;flex-wrap:wrap;font-family:Open Sans;font-size:.875rem;font-weight:400;height:auto;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;overflow-y:auto;padding:.25rem;transition:height .25s ease}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}::slotted(wui-tag){margin:0 .75rem .75rem 0}:host([size=md]){max-height:8rem}:host([size=lg]){max-height:15rem}:host([type=contained])>div{background-color:var(--jw-theme-form-field-default-bg-color);border:1px solid var(--jw-theme-form-border-regular-default-border-color);border-radius:.25rem;padding:.75rem}";

const WuiTagList$1 = /*@__PURE__*/ proxyCustomElement(class WuiTagList extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Size of the scroll container
         */
        this.size = 'md';
        /**
         * Variant of the tag list
         */
        this.type = 'default';
    }
    render() {
        return (h(Host, { key: 'e0bd7fae3712d03728032918e6181057d4d3d1b0' }, h("div", { key: '5059cfa7401ac4fba32b83023c647b5c0275ee4a' }, h("slot", { key: '4f8b0051fbfd9ff6fef8f97c9a8d055d275667fa' }))));
    }
    static get style() { return tagListCss; }
}, [257, "wui-tag-list", {
        "size": [513],
        "type": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tag-list"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tag-list":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTagList$1);
            }
            break;
    } });
}
defineCustomElement$1();

const WuiTagList = WuiTagList$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTagList, defineCustomElement };
